// extracted by mini-css-extract-plugin
export default {"Container":"Media_Container__Okv8H","Header":"Media_Header__cESWf","RightArrow":"Media_RightArrow__eXLOY","List":"Media_List__rp49r","Link":"Media_Link__pxYb7"};